import React from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer className="bg-blue-900 text-white">
      {/* Top part: three columns */}
      <div className="px-4 sm:px-6 md:px-10 py-12 md:py-16 max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
        {/* Column 1: Logo */}
        <div className="flex flex-col items-center md:items-start">
          <img
            src="/images/falcon.png"
            alt="Falcon Logo"
            style={{
              height: "320px",
              maxHeight: "320px",
              minHeight: "150px",
              width: "auto",
              marginBottom: "2rem",
              display: "block",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          />
        </div>
        {/* Column 2: Quick Links */}
        <div className="flex flex-col items-center">
          <h3 className="text-xl sm:text-2xl font-semibold mb-4 md:mb-6">Quick Links</h3>
          <ul className="space-y-2 text-base sm:text-lg">
            <li>
              <Link to="/" className="hover:underline">Home</Link>
            </li>
            <li>
              <Link to="/team" className="hover:underline">Our Team</Link>
            </li>
            <li>
              <Link to="/services" className="hover:underline">Our Services</Link>
            </li>
            <li>
               <Link to="/blog" className="hover:underline">Blog </Link>
            </li>
            <li>
              <Link to="/contact" className="hover:underline">Contact Us</Link>
            </li>
          </ul>
        </div>
        {/* Column 3: Get In Touch */}
        <div className="flex flex-col items-center md:items-end text-center md:text-right">
          <h3 className="text-xl sm:text-2xl font-semibold mb-4 md:mb-6">Get In Touch</h3>
          <p className="text-base sm:text-lg leading-relaxed">
            <strong>Address:</strong><br />
            Suite 290, 6815 - 8th Street NE<br />
            Calgary, Alberta T2E 7H7<br />
            Canada
          </p>
          <p className="mt-4 text-base sm:text-lg leading-relaxed">
            <strong>Phone:</strong> (587) 971-0447 <br />
            <strong>Fax:</strong> (587) 791-1838 <br />
            <strong>Email:</strong>{" "}
            <a href="mailto:smehta@falconlawoffice.com" className="hover:underline break-all">
              info@falconlawoffice.ca
            </a>
          </p>
          <p className="mt-4 text-base sm:text-lg leading-relaxed">
            <strong>Working Hours:</strong><br />
            Mon – Fri: 8:30 AM – 4:30 PM<br />
            
          </p>
        </div>
      </div>

      {/* Legal Footnote */}
      <div className="bg-blue-900 border-t border-blue-800">
        <p className="italic text-center text-gray-200 text-xs sm:text-sm py-5 max-w-3xl mx-auto px-2 leading-relaxed">
          All information and content contained herein is to be considered general legal information. It is not intended to be a substitute for legal advice. For legal advice we recommend you contact a lawyer and enter into a formal retainer agreement.
        </p>
      </div>
<div className="bg-blue-950 border-t border-blue-900 relative">
  <p className="text-center text-xs sm:text-sm font-bold py-3 text-white m-0">
    © {new Date().getFullYear()} Falcon Law. All rights reserved.
  </p>
     <a
    href="https://instagram.com/rehanarpan909"
    target="_blank"
    rel="noopener noreferrer"
    className="absolute right-3 top-1/2 -translate-y-1/2 text-[11px] sm:text-xs text-blue-200 hover:text-white transition"
    style={{ fontWeight: 370, letterSpacing: "0.01em" }}
  >
    Designed by: rehanarpan909
  </a>
  </div>
{/* </div> */}
    </footer>
  );
}
